import { useQuery } from '@tanstack/react-query';
import { fetchDealersByIds } from '../services/dealers';
import { dealerKeys } from './useDealersQuery';
import type { DealerSummary } from '../types/dealers.types';

export const useDealersByIds = (ids: string[], enabled = true) => {
    const cleaned = Array.from(new Set(ids.filter(Boolean))).sort();
    return useQuery<DealerSummary[]>({
        queryKey: dealerKeys.byIds(cleaned),
        queryFn: () => fetchDealersByIds(cleaned),
        enabled: enabled && cleaned.length > 0,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};

export const buildDealerNameMap = (dealers: DealerSummary[] | undefined): Map<string, string> => {
    const map = new Map<string, string>();
    (dealers ?? []).forEach((d) => map.set(d.id, d.name));
    return map;
};
